goog.provide("shadow.js.shim.module$src$svg$artwork$template_svg$default");
shadow.js.shim.module$src$svg$artwork$template_svg$default = shadow.js.shim.module$src$svg$artwork$template_svg.default;
